//自定义组件
export const Tools = {
    cookie: {
        addCookie: function(c_name, value, expire,domain){
          var textDomain = domain ? ';domain='+domain : '';
          if(expire === "null"){
            document.cookie=c_name+ "=" +escape(value)+ "" + "; path=/"+textDomain;
          }else if (expire == null){
            var exdate=new Date();
            exdate.setHours(exdate.getHours()+8);
            // exdate.setHours(exdate.getHours()+1000);
            document.cookie=c_name+ "=" +escape(value) + ";expires="+exdate.toGMTString() + "; path=/"+textDomain
          }else{
            var exdate=new Date(parseInt(expire) * 1000);
            // var exdate=new Date(parseInt(expire) * 1000000);
            document.cookie=c_name+ "=" +escape(value) + ";expires="+exdate.toGMTString() + "; path=/"+textDomain
          }
        },
        getCookieOld: function(c_name){
            if (document.cookie.length>0)
            {
                // console.log(c_name, Tools.cookie.getCookieUse(c_name))
                var c_start=document.cookie.indexOf(' ' + c_name + '=')
                if (c_start!=-1)
                {
                    c_start=c_start + c_name.length+1
                    var c_end=document.cookie.indexOf(";",c_start)
                    if (c_end==-1) c_end=document.cookie.length
                    return unescape(document.cookie.substring(c_start,c_end))
                }
            }
            return ""
        },
        getCookie: function(c_name) {
          var arr,reg=new RegExp("(^| )"+c_name+"=([^;]*)(;|$)");
          if(arr=document.cookie.match(reg)) {
            if(c_name == 'real_name'){
              return decodeURI(unescape(arr[2]));
            }else{
              return unescape(arr[2]);
            }
          } else {
            return "";
          }
        },
        removeCookie: function(name,domain){
          Tools.cookie.addCookie(name, null,0,domain);
        }
    }
}




// WEBPACK FOOTER //
// ./src/assets/js/common.js